// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3BpNJ","info":"Note_info__KDU54","note":"Note_note__2oSk6","actions":"Note_actions__3jjLn"};